import axios from '@axios'

export default {
  joinPartneroPrograms() {
    return axios.post('/api/partnero-programs/join')
  },
}
